<section class="pricing-comparison-section" aria-labelledby="comparison-heading">
  <div class="container">
    <p class="section-label text-center">Compare plans</p>
    <h2 id="comparison-heading" class="section-title">What's included</h2>
    <p class="section-subtitle">
      Core MemberTrace is included in every plan. The table below shows only what changes across Society, Growth, and Operator.
    </p>

    <div class="core-included">
      <h3>Core MemberTrace — included in every plan</h3>
      <p>
        Memberships, renewals, events, communications, payments, directories, standard reporting, a hosted branded portal, and Included Support.
      </p>
      <ul>
        <li *ngFor="let item of coreIncluded">{{ item }}</li>
      </ul>
    </div>

    <section class="comparison-desktop comparison-scroll" aria-label="Plan comparison table">
      <table class="comparison-table">
        <caption class="visually-hidden">Feature comparison across Society, Growth, and Operator</caption>
        <thead>
          <tr>
            <th scope="col" class="feature-col">Capability</th>
            <th scope="col" *ngFor="let plan of plans">{{ plan.label }}</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let category of categories">
            <tr class="category-row">
              <th scope="colgroup" [attr.colspan]="plans.length + 1">{{ category.name }}</th>
            </tr>
            <tr *ngFor="let row of category.rows">
              <th scope="row" class="feature-col">{{ row.name }}</th>
              <td *ngFor="let plan of plans" [attr.data-plan]="plan.label">
                <ng-container *ngTemplateOutlet="cellTpl; context: { value: row.values[plan.id] }"></ng-container>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </section>

    <div class="comparison-mobile">
      <mat-accordion class="comparison-accordion" multi>
        <mat-expansion-panel *ngFor="let category of categories; let i = index" [expanded]="i === 0">
          <mat-expansion-panel-header>
            <mat-panel-title>{{ category.name }}</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="mobile-feature" *ngFor="let row of category.rows">
            <p class="mobile-feature-name">{{ row.name }}</p>
            <div class="mobile-plan-grid">
              <div class="mobile-plan-cell" *ngFor="let plan of plans">
                <span class="mobile-plan-label">{{ plan.label }}</span>
                <ng-container *ngTemplateOutlet="cellTpl; context: { value: row.values[plan.id] }"></ng-container>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <p class="comparison-note">
      Managed Support is an optional add-on for any plan. Operator Workspace is exclusive to teams managing multiple organizations.
    </p>
  </div>
</section>

<ng-template #cellTpl let-value="value">
  <span
    class="cell-value"
    [class.is-included]="isIncluded(value)"
    [class.is-excluded]="isExcluded(value)"
    [class.is-note]="isNote(value)">
    <span class="cell-mark" aria-hidden="true" *ngIf="isIncluded(value)">✓</span>
    <span class="cell-mark" aria-hidden="true" *ngIf="isExcluded(value)">—</span>
    <span class="cell-text">{{ cellLabel(value) }}</span>
  </span>
</ng-template>
